export default "__VITE_ASSET__Dg4Ct7X9__"